export function filesToFormData(files: FileList, name: string): FormData {
  return Array.from(files).reduce((frmData: FormData, current) => {
    frmData.append(name, current);
    return frmData;
  }, new FormData());
}
